if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.addOnform = this.closest('.shopify-section').querySelector('addon-product');
      this.includeParent = this.dataset.includeParent;
      this.showModal = this.dataset.showModal || 'true';
      if (this.cartNotification) {
        this.cart = this.cartNotification;
      } else {
        this.cart = this.cartDrawer;
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    getItems() {
      const formData = JSON.parse(serializeForm(this.form));
      let uniqueMessage = this.getUniqueMessage(formData);
    
    
      let itemFromForm = this.createItemFromForm(formData, uniqueMessage);
    
      if (this.hasAddons && this.includeParent === 'true') {
        let addonItem = this.createAddonItem(formData, uniqueMessage);
        return { items: [itemFromForm, addonItem] };
      } else {
        return { items: [itemFromForm] };
      }
    }
    
    getUniqueMessage(formData) {
      return formData.properties && formData.properties['_message']
             ? formData.properties['_message']
             : Date.now().toString(36) + Math.random().toString(36).substring(2);
    }
    
    createItemFromForm(formData, uniqueMessage) {
      let item = {
        quantity: formData.quantity,
        id: formData.id,
        properties: { '_message': uniqueMessage }
      };
    
      if (!this.hasAddons || this.includeParent === 'false') {
        let message = this.hasAddons ? this.addOnform.querySelector('textarea')?.value : '';
        if (message) {
          item.properties['Message'] = message;
        }
      }
    
      return item;
    }
    
    createAddonItem(formData, uniqueMessage) {
      let checkbox = this.addOnform.querySelector('input[type="checkbox"]');
      let message = this.addOnform.querySelector('textarea')?.value;
    
      return {
        quantity: formData.quantity,
        id: checkbox?.value,
        properties: {
          'Message': message,
          'Product': formData.id,
          '_message': uniqueMessage
        }
      };
    }
    
    
    validateForm() {
      if (this.hasAddons) {
        const textarea = this.addOnform.querySelector('textarea');
        const errorWrapper = this.addOnform.querySelector('.addon-product__error-message-wrapper');
        const errorMessage = errorWrapper.querySelector('.addon-product__error-message');

        if (!textarea.value.trim()) {
          errorWrapper.removeAttribute('hidden');
          errorMessage.textContent = window.productStrings.emptyNote;
          return false;
        }

        // Hide error if validation passes
        errorWrapper.setAttribute('hidden', true);
      }
      return true;
    }
    
    
    
    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      if (!this.validateForm()) return; // Halt submission if validation fails

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      const items = this.getItems();

      let props ={...items.items[0].properties};
      document.querySelectorAll("[name*='properties']").forEach(e => {
            let propName = e.name.split("[")[1].split("]")[0];
            let propValue = e.value;
            props[propName] = propValue;
            // items.items[0].properties[propName] = propValue;
      });
      items.items[0].properties = props;

      

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...items,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const quickAddModal = this.closest('cart-notification');
          if (quickAddModal) {
            window.location = window.routes.cart_url;
            return;
          }
          if (this.showModal === 'true') {
            this.cart.renderContents(response);
          } else {
          const oldButtonText = submitButton.textContent;
          submitButton.querySelector('span').textContent = window.productStrings.productAdded;
          setTimeout(() => {
            submitButton.querySelector('span').textContent = oldButtonText;
          }, 5000);
          }


        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          if (document.querySelector('cart-link')) {
            document.querySelector('cart-link').refreshCart();
            document.querySelector('cart-link').showMessage();
          }

          if (this.closest('.shopify-section').querySelector('addon-product')) {
            const addonProduct = this.closest('.shopify-section').querySelector('addon-product');
            addonProduct.input.checked = false;
            addonProduct.input.dispatchEvent(new Event('change', { bubbles: true }));
            addonProduct.note.querySelector('textarea').value = '';

          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class StickyForm extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button[type="submit"]');
    console.log(this.button);
    this.button.addEventListener('click', this.onButtonClick.bind(this));

  }

  connectedCallback() {
    this.productFormButton = document.querySelector('product-form form[action="/cart/add"]');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.form = document.querySelector('product-form');
    


    this.createObserver();
  }
  onButtonClick(e) {
    e.preventDefault();
    this.productForm = document.querySelector('product-form');
    this.form = document.querySelector('product-form form');
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    if (this.cartNotification) {
      this.cart = this.cartNotification;
    } else {
      this.cart = this.cartDrawer;
    }
    if (this.cart) {
      this.productForm.onSubmitHandler(e);
    } else {
      this.productForm.onSubmitHandlerCart(e);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.productFormButton);
  }

  isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (!this.preventReveal) {

      if (this.isInViewport(this.productFormButton)) {
        requestAnimationFrame(this.hideForm.bind(this));
      } else {
        requestAnimationFrame(this.revealForm.bind(this));
      }
      if (this.isInViewport(document.querySelector('footer .footer__content-bottom'))) {
        requestAnimationFrame(this.hideForm.bind(this));
      }
      
    } else {
      window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

    }
    return false;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop + window.innerHeight > this.headerBounds.bottom ) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }


    this.currentScrollTop = scrollTop;
  }

  hideForm() {
    this.classList.add('sticky-form-hidden');
    this.classList.remove('sticky-form-sticky');

  }

  revealForm() {
    this.classList.add('sticky-form-sticky', 'animate');
    this.classList.remove('sticky-form-hidden');
  }

  reset() {
    this.classList.remove('sticky-form-hidden', 'sticky-form-sticky', 'animate');
  }

}

customElements.define('sticky-form', StickyForm);


class AddonProduct  extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="checkbox"]');
    this.note = this.querySelector('.product-addon__note');
    this.form = this.closest('.shopify-section').querySelector('product-form');
    this.includeParent = this.dataset.includeParent;
    this.init();
    this.setupCharacterCounter(); // Setup character counter after initialization
    
  }

  init() {
    this.input.addEventListener('change', this.onInputChange.bind(this));
  }

  setupCharacterCounter() {
    if (!this.note) return;

    const textarea = this.note.querySelector('textarea');
    this.counterDiv = this.note.querySelector('div'); // Reference to the counter div
    this.maxLength = textarea.getAttribute('maxlength');

    textarea.addEventListener('input', this.updateCounter.bind(this));


    // Initialize counter at page load
    this.updateCounter();
  }

  updateCounter() {
    const currentLength = this.note.querySelector('textarea').value.length;
    this.counterDiv.textContent = `${currentLength}/${this.maxLength}`;
  }

  checkOption() {
    if (!this.note) return;
    this.note.removeAttribute('hidden');
    this.form.hasAddons = true;
    this.setCartButton('add');
    this.note.querySelector('textarea').focus();
    trapFocus(this.note.querySelector('textarea'));
  }

  uncheckOption() {
    if (!this.note) return;
    this.note.setAttribute('hidden', true);
    this.form.hasAddons = false;
    this.setCartButton('open');
    this.focus();
    trapFocus(this);

  }

  setCartButton(type) {
    const button = this.form.querySelector('button[type="submit"]');
    if (this.includeParent === 'true') return;
      
    if (type === 'add') {
      document.querySelector('#cart-notification-links button.button--to-cart').classList.remove('hidden');
      document.querySelector('#cart-notification-links a.button--to-cart').classList.add('hidden');

    } else {
      document.querySelector('#cart-notification-links button.button--to-cart').classList.add('hidden');
      document.querySelector('#cart-notification-links a.button--to-cart').classList.remove('hidden');
    }
  }

  onInputChange() {
    if (this.input.checked) {
      this.checkOption();
    } else {
      this.uncheckOption();
    }
  }
  
}
 
customElements.define('addon-product', AddonProduct );